export default __webpack_public_path__ + "static/media/IconAuto1.65df94dc.png";